import { render, staticRenderFns } from "./PagesEcom.pug?vue&type=template&id=74f9621f&lang=pug&external"
import script from "./PagesEcom.js?vue&type=script&lang=js&external"
export * from "./PagesEcom.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports